import { OrdinaryObject } from 'src/modules/utils/shared/ordinary-object.model';

export class TemplateFieldListItem {

    caption = "";
    data: OrdinaryObject;
    children: TemplateFieldListItem[];
    visible = true;
}
